//EXPERIMENT CONSTANTS
export const PROMOTE_ADDONS_ON_PRICING_PAGES_EXPERIMENT =
    "promote-addons-on-pricing-pages";
export const PROMOTE_ADDONS_ON_PRICING_PAGES_VARIANT =
    "pricing-promote-addons-variant";
